module.exports = __webpack_public_path__ + "images/home/index/values-growth-bg-7fee02e44aa11ad7b38a60e494d70919.png";